import * as React from 'react';
import { useEffect } from 'react';
import { PageLoading, StickyNavigation } from 'ui-toolkit';
import { useSelector } from 'react-redux';
import { RootStore } from '../../store/types';
import { useAppDispatch } from '../../store/store';
import {
  addLenderContactAction,
  addLenderContactSlice,
  editLenderContactAction,
  editLenderContactSlice,
  getLenderContactsAction,
  getLenderInfoAction,
} from '../../store/order/clientLenderContacts/slices';
import { LenderCompanyPage } from './LenderCompanyPage';
import { ILenderContactData } from '../../types/contacts/ILenderContact';
import { UserProfileContainer } from '../../components/userProfile/UserProfileContainer';
import { getAllLendersAsyncAction } from 'store/lenders/lendersSlice';
import { useKeyToSelect } from 'store/createKeyedDataAsyncSlice';
import { useParams } from 'react-router-dom';
import { UUID } from '../../types/shared/UUID';
import { useListLendersQuery } from '../../API/lenders/LenderCompanyApi';

export const LenderCompanyContainer: React.FC = () => {
  const { lenderId } = useParams<{ lenderId: UUID }>();
  const dispatch = useAppDispatch();
  const { lenderContacts, actionLenderContact, addLenderContact, editLenderContact } = useSelector(
    (store: RootStore) => store.clientLenderContacts
  );
  const { data, fetchError, fetchStatus } = useKeyToSelect(
    lenderId,
    (store: RootStore) => store.clientLenderContacts.lenderInfo
  );

  useEffect(() => {
    dispatch(getAllLendersAsyncAction());
    dispatch(getLenderInfoAction(lenderId));
    dispatch(getLenderContactsAction(lenderId));
  }, [dispatch, lenderId]);

  const { data: allLenders = [], isLoading: isLenderCompanyLoading } = useListLendersQuery({
    includeDeactivated: true,
  });

  const company = allLenders.find((company) => company.id === lenderId);

  const onAddNewContact = async (contact: ILenderContactData) => {
    await dispatch(addLenderContactAction({ lenderId, contact }));
    await dispatch(getLenderContactsAction(lenderId));
  };
  const onResetAdd = () => dispatch(addLenderContactSlice.actions.reset({}));

  const onEditContact = async (contact: ILenderContactData) => {
    await dispatch(editLenderContactAction({ lenderId, contact }));
    await dispatch(getLenderContactsAction(lenderId));
  };
  const onResetEdit = () => dispatch(editLenderContactSlice.actions.reset({}));

  return (
    <>
      {fetchStatus.fetching || isLenderCompanyLoading ? (
        <PageLoading isLoading={true} />
      ) : (
        <>
          <StickyNavigation activeMain={'Lenders'} profile={<UserProfileContainer />} />
          {data && (
            <LenderCompanyPage
              lenderId={lenderId}
              pageError={fetchError || lenderContacts.fetchError}
              companyName={company && company.name ? company.name : lenderId}
              lenderInfo={data}
              lenderContacts={lenderContacts.data}
              getContactFetchStatus={lenderContacts.fetchStatus}
              addContactFetchStatus={addLenderContact.fetchStatus}
              addContactError={addLenderContact.fetchError}
              actionContactError={actionLenderContact.fetchError}
              editContactFetchStatus={editLenderContact.fetchStatus}
              editContactError={editLenderContact.fetchError}
              onAddContact={onAddNewContact}
              onAddContactReset={onResetAdd}
              onEditContact={onEditContact}
              onEditContactReset={onResetEdit}
            />
          )}
        </>
      )}
    </>
  );
};
